<section>
  <span class="open-slide">
    <gen-button [type]="'quite'"
                [fullSize]="true"
                (click)="showSlideMenu()"
                [iconClass]="'fa fa-bars'">
    </gen-button>
  </span>
  <div class="side-menu slide-is-closed" #slidemenuContent>
    <div class="slide-actions">
      <gen-button [type]="'quite'"
                  [fullSize]="true"
                  (click)="closeSlideMenu()"
                  [iconClass]="'fa fa-angle-double-left'">
      </gen-button>
  </div>
  <div>
    <ispm-layout-engine-menu-item [config]="item"
                                  class="ui-g ui-g-nopad ui-md-12 ui-lg-12 ui-xl-12 ui-sm-3"
                                  *ngFor="let item of config.items">
    </ispm-layout-engine-menu-item>
  </div>
  </div>
</section>
